// frontend/src/components/menus/BottomMenu.tsx
import React from 'react';
import { List } from '@mui/material';
import {
  StyledBottomDrawer,
  StyledListItem,
  StyledListItemText,
  StyledListItemIcon,
  defaultBottomDrawerPositionSx,
} from './shared/DrawerMenuElements';

export interface BottomMenuItem {
  key: string;
  icon?: React.ReactElement;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface BottomMenuProps {
  open: boolean;
  onClose: () => void;
  items: BottomMenuItem[];
  // Positioning of the drawer's right edge, to track the trigger FAB.
  // Defaults match a fixed FAB at right: 10% of viewport. Pass an object
  // (optionally with breakpoint keys) for implementations whose FAB sits
  // in a different containing block, e.g. position: 'absolute'.
  right?: string | number;
  bottom?: string | number;
  left?: string | number;
  sx?: object;
}

const BottomMenu: React.FC<BottomMenuProps> = ({
  open,
  onClose,
  items,
  right,
  bottom,
  left,
  sx,
}) => {
  const handleItemClick = (item: BottomMenuItem) => {
    if (item.disabled) return;
    item.onClick();
    onClose();
  };

  const hasOverride =
    right !== undefined || bottom !== undefined || left !== undefined || sx;

  const paperPositionSx = hasOverride
    ? { left: left ?? 'auto', right, bottom, ...sx }
    : defaultBottomDrawerPositionSx;

  return (
    <StyledBottomDrawer
      open={open}
      onClose={onClose}
      paperPositionSx={paperPositionSx}
    >
      <List disablePadding>
        {items.map((item) => (
          <StyledListItem
            key={item.key}
            disableGutters
            onClick={() => handleItemClick(item)}
            sx={{
              cursor: item.disabled ? 'not-allowed' : 'pointer',
              opacity: item.disabled ? 0.5 : 1,
              pointerEvents: item.disabled ? 'none' : 'auto',
              paddingLeft: '1rem',
            }}
          >
            {item.icon && <StyledListItemIcon>{item.icon}</StyledListItemIcon>}
            <StyledListItemText primary={item.label} />
          </StyledListItem>
        ))}
      </List>
    </StyledBottomDrawer>
  );
};

export default BottomMenu;
